import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { HowPaymentWorksDialog } from './HowPaymentWorksDialog';

type CardHoldCardProps = {
  amount: string;
  description: string;
  title: string;
};

export const CardHoldCard = ({
  amount,
  description,
  title,
}: CardHoldCardProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation('checkout');

  return (
    <div className="flex flex-col gap-2 rounded-sm bg-neutral-1 p-4">
      <div className="flex flex-row justify-between gap-3 font-bold">
        <span>{title}</span>
        <span>{amount}</span>
      </div>
      <span className="text-pretty">{description}</span>
      <button
        className="hyperlink self-start"
        onClick={() => setDialogOpen(true)}
        type="button"
      >
        {t('review.cardHold.howItWorks')}
      </button>
      <HowPaymentWorksDialog
        onClose={() => setDialogOpen(false)}
        open={dialogOpen}
      />
    </div>
  );
};
